import { combineReducers } from "redux";
import UserIdReducer from "./userId";
import ActiveYearReducer from "./activeYear";
import ActiveCompanyFormReducer from "./activeCompanyForm";
import LocalDataList from "./localDataList";
import ActivePageReducer from "./activePage";
import TotalFixedCostReducer from "./totalFixedCost";
import TotalYearGrossMarginReducer from "./totalYearGrossMargin";
import TotalAnnualSalesReducer from "./totalAnnualSales";
import SalaryCalculationReducer from "./salaryCalculation";
import SalaryCalculationYear1Reducer from "./salarycalculationYear1";
import SalaryCalculationYear2Reducer from "./salarycalculationYear2";
import SalaryCalculationYear3Reducer from "./salarycalculationYear3";
import TotalMeasuredCostsYearReducer from "./totalMeasuredCostsYear";
import TotalMeasuredHoursYearReducer from "./totalMeasuredHoursYear";
import TotalYearGrossMarginPerYearReducer from "./totalYearGrossMarginPerYear";
import TotalFixedCostPerYearReducer from "./totalFixedCostPerYear";
import ErrorMessageReducer from "./errorMessage";
import SaveMessageReducer from "./saveMessage";
import SizeForMobileReducer from "./sizeForMobile";

const rootReducer = combineReducers({
  userId: UserIdReducer,
  year: ActiveYearReducer,
  companyForm: ActiveCompanyFormReducer,
  localDataList: LocalDataList,
  activePage: ActivePageReducer,
  totalFixedCost: TotalFixedCostReducer,
  totalYearGrossMargin: TotalYearGrossMarginReducer,
  totalAnnualSales: TotalAnnualSalesReducer,
  salaryCalculation: SalaryCalculationReducer,
  salaryCalculationYear1: SalaryCalculationYear1Reducer,
  salaryCalculationYear2: SalaryCalculationYear2Reducer,
  salaryCalculationYear3: SalaryCalculationYear3Reducer,
  TotalMeasuredCostsYear: TotalMeasuredCostsYearReducer,
  TotalMeasuredHoursYear: TotalMeasuredHoursYearReducer,
  TotalYearGrossMarginPerYear: TotalYearGrossMarginPerYearReducer,
  TotalFixedCostPerYear: TotalFixedCostPerYearReducer,
  errorMessage: ErrorMessageReducer,
  saveMessage: SaveMessageReducer,
  sizeForMobile: SizeForMobileReducer,
});

export default rootReducer;
